module.exports = __webpack_public_path__ + "static/media/Vector1.1f5b9dc1.svg";